import { ref, computed } from 'vue'

const STORAGE_KEY = 'cml_auth'

// Shared state across all components
const authData = ref(null)

// Load from localStorage on initialization
const loadAuth = () => {
  try {
    const stored = localStorage.getItem(STORAGE_KEY)
    if (stored) {
      authData.value = JSON.parse(stored)
    }
  } catch (error) {
    console.error('Failed to load auth data:', error)
    localStorage.removeItem(STORAGE_KEY)
  }
}

// Initialize on first import
loadAuth()

export function useAuth() {
  const login = (libraryCard, pin, patronInfo = null) => {
    const data = {
      libraryCard,
      pin,
      patronInfo,
      timestamp: Date.now()
    }

    authData.value = data
    localStorage.setItem(STORAGE_KEY, JSON.stringify(data))
  }

  const logout = () => {
    authData.value = null
    localStorage.removeItem(STORAGE_KEY)
  }

  const isAuthenticated = () => {
    return authData.value !== null &&
           authData.value.libraryCard &&
           authData.value.pin
  }

  const getCredentials = () => {
    if (!authData.value) return null
    return {
      libraryCard: authData.value.libraryCard,
      pin: authData.value.pin
    }
  }

  const getPatronInfo = () => {
    return authData.value?.patronInfo || null
  }

  const updatePatronInfo = (patronInfo) => {
    if (authData.value) {
      authData.value.patronInfo = patronInfo
      localStorage.setItem(STORAGE_KEY, JSON.stringify(authData.value))
    }
  }

  return {
    login,
    logout,
    isAuthenticated,
    getCredentials,
    getPatronInfo,
    updatePatronInfo,
    authData: computed(() => authData.value)
  }
}
